import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {create as createRecord} from "app/requests/admin/newsletters";
import {usePrompt} from "lib/hooks";
import useAppContext from "lib/hooks/use-app-context";
import {valueFrom, valueFromTarget} from "lib/form";
import {withoutBlankValues} from "lib/object";
import Form from "./form";

export default function AdminNewslettersNew() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const [block, setBlock] = useState(false);
  const [record, setRecord] = useState({
    content: "",
    preview_text: "",
    subject: ""
  });

  usePrompt({when: block});

  const onChange = ({target}) => {
    setBlock(true);
    setRecord({...record, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (e) => {
    e.preventDefault();

    setBlock(false);
    createRecord({newsletter: withoutBlankValues({...record})}).then((data) => {
      if(data.success) {
        navigate("/admin/newsletters", {state: {message: data.message, type: "success"}});
      } else {
        dispatch(createNotification({content: data.message, type: "danger"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({defaultValue, name, objects: [record]});

  return (
    <div className="container-fluid">
      <h1 className="text-center">New Newsletter</h1>
      <Form {...{onChange, onSubmit, value}} />
    </div>
  );
}
